import { Box, IconButton, InputBase, Stack, useTheme } from "@mui/material";
import React from "react";
import {
  galleryView,
  galleryViewActive,
  searchIcon,
  tableView,
  tableViewActive,
} from "../../../assets";

export const SearchAndView = ({
  view,
  setView,
  option = true,
  searchVar,
  setFiltered,
}) => {
  const theme = useTheme();
  return (
    <Stack
      direction={"row"}
      justifyContent="flex-start"
      gap="20px"
      sx={{
        marginBottom: "25px",
        width: "100%",
        paddingTop: "16px",
        paddingLeft: "16px",
      }}
    >
      <Box
        display="flex"
        backgroundColor={theme.palette.secondary.dark}
        borderRadius="3px"
        flex={8}
      >
        <IconButton type="button" sx={{ p: 1 }}>
          <img src={searchIcon} alt="search" />
        </IconButton>
        <InputBase
          sx={{ ml: 2, flex: 1, fontSize: "14px" }}
          placeholder="Search By Name or Collection"
          value={searchVar}
          onChange={(e) => setFiltered(e)}
        />
      </Box>

      <Box
        display="flex"
        backgroundColor={theme.palette.secondary.dark}
        borderRadius="3px"
        flex={1}
        visibility={option ? "visible" : "hidden"}
      >
        <img
          src={view === "gallery" ? galleryViewActive : galleryView}
          alt="gallery"
          onClick={() => setView("gallery")}
        />
        <img
          src={view === "table" ? tableViewActive : tableView}
          alt="table"
          onClick={() => setView("table")}
          style={{ marginLeft: 10 }}
        />
      </Box>
    </Stack>
  );
};
